import React, { useRef, useEffect, use } from 'react';
import PropTypes from 'prop-types';
import { select } from 'd3';
import { drawSimpleKey } from './RadarChart.drawing';

const SimpleRadarKey = ({
  visPalette,
  primaryColor,
  secondaryColor,
  fontScaler = 1,
  subjectLabel = 'Player',
  width = 300,
  height = 40,
  opacity = 1,
}) => {
  const ref = useRef();

  useEffect(() => {
    const svg = select(ref.current);
    svg.selectAll('*').remove();
    const keyG = svg.append('g');
    drawSimpleKey(
      keyG,
      visPalette,
      primaryColor,
      secondaryColor,
      fontScaler,
      subjectLabel
    );
  }, [visPalette, primaryColor, secondaryColor, fontScaler, subjectLabel]);

  useEffect(() => {
    const svg = select(ref.current);
    svg.style('opacity', opacity);
  }, [opacity]);

  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      style={{ display: 'block' }}
      data-testid="simple-radar-key"
    />
  );
};

SimpleRadarKey.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  visPalette: PropTypes.object.isRequired,
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  fontScaler: PropTypes.number,
  subjectLabel: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  opacity: PropTypes.number,
};

export default SimpleRadarKey;
